import { Dictionary } from '../types/generics';
import { IACDDevice } from '../types/device';
import { isEmpty, isEqual, xorWith } from 'lodash';
import { UserType } from '../constants/data';
import { IUser } from '../types/user';

import featureFlag from "../config/feature-flag.json";

export function optClasses(classes: string, opts: Dictionary<boolean>): string {
  let out = classes;

  for (const key in opts) {
    if (opts[key] === true) {
      out += ` ${key}`;
    }
  }

  return out.trim();
}

// check if hub has active device
export function isDeviceOn(device: IACDDevice): boolean {
  const { apps } = device;
  return apps.filter((app) => app.state === 'on').length > 0;
}

export function formatTime(seconds: number): string {
  seconds -= parseInt(localStorage.getItem('timeDelta'));
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = (seconds % 3600) % 60;

  return `${h}h ${m < 10 ? `0${m}` : m}m ${s < 10 ? `0${s}` : s}s`;
}

export function isArrayEqual(x, y) {
  return isEmpty(xorWith(x, y, isEqual));
}

export function isTeamAdmin(type: string): boolean {
  return type === UserType.parent || type === UserType.teamAdmin
}

export function isAllowedUser(user: IUser, type: string, feature: string, subFeature?: string): boolean {
  const tags = featureFlag[type]?.[feature]?.usertags || featureFlag[type]?.[feature]?.[subFeature]?.usertags;

  if (tags) {
    for (let i = 0; i < tags.length; i++) {
      for( let j = 0; j < user?.tags?.length || 0; j++) {
        if(tags[i] === user?.tags[j]) return true;
      }
    }
    return false;
  }
  return true;
}

export function  getSecondaryPostContent (data){
  const content = getHtmlContent(
    data?.postContent||
    data?.message ||
    data?.content ||
    data?.details ||
    data?.post ||
    data?.info ||
    data?.body||
    data?.title||
    data?.attachments
  );
  return content;
};

export function  getHtmlContent  (htmlString){
  if (!htmlString) return ""; // Handle empty input

  // Find the first <div> tag and its matching </div>
  const divMatch = htmlString.match(/<div[^>]*>([\s\S]*)<\/div>/);

  if (divMatch && divMatch.length >= 2) {
    return divMatch[0]; // Return the full <div> including its content
  } else {
    // If no closing </div> is found, return from the first <div> to the end of the string
    const startDivIndex = htmlString.indexOf("<div");
    return startDivIndex !== -1
      ? htmlString.slice(startDivIndex)
      : htmlString;
  }
};

export function  formatDate(dateString?: string): string  {
  if (!dateString) return "Invalid Date"; // Handle null or undefined
  const isValidFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(
    dateString
  );
  if (!isValidFormat) return "Invalid Date Format"; // Handle invalid format
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Invalid Date";
  return date
    .toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    })
    .replace(",", " at");
};

export function  getSecondaryPostListContent (data) {
  return stripHtmlAndGetFirstSentence(
      data?.message ||
      data?.content ||
      data?.details ||
      data?.postContent ||
      data?.post ||
      data?.info ||
      data?.body 
  );
};
export const stripHtmlAndGetFirstSentence = (() => {
  const parser = new DOMParser();
  return (htmlString?: string): string => {
      if (!htmlString) return "";
      let extractedText = "";
      const doc = parser.parseFromString(htmlString, "text/html");
      const paragraphs = doc.querySelectorAll("p");
      if (paragraphs.length > 0) {
          extractedText = Array.from(paragraphs)
              .map((p) => p.textContent?.trim() ?? "")
              .join("\n");
      } else {
          extractedText = doc.body.textContent?.trim() ?? "";
      }
      let truncatedText = extractedText.slice(0, 100);
      if (extractedText.length > 100) {
          const lastSpace = truncatedText.lastIndexOf(" ");
          truncatedText =
              lastSpace > 0
                  ? truncatedText.slice(0, lastSpace) + "..."
                  : truncatedText + "...";
      }
      return truncatedText;
  };
})();


